// Sentry client-side initialization. Loaded by Next.js automatically per
// the @sentry/nextjs v8+ convention. The legacy sentry.client.config.ts
// pattern is no longer used.

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/lists/:userId/:listId\",\"regex\":\"^/lists/([^/]+)/([^/]+)$\",\"paramNames\":[\"userId\",\"listId\"],\"hasOptionalPrefix\":false},{\"path\":\"/show/:showId\",\"regex\":\"^/show/([^/]+)$\",\"paramNames\":[\"showId\"],\"hasOptionalPrefix\":false},{\"path\":\"/show/:showId/season/:seasonNum/episode/:episodeNum\",\"regex\":\"^/show/([^/]+)/season/([^/]+)/episode/([^/]+)$\",\"paramNames\":[\"showId\",\"seasonNum\",\"episodeNum\"],\"hasOptionalPrefix\":false},{\"path\":\"/u/:handle\",\"regex\":\"^/u/([^/]+)$\",\"paramNames\":[\"handle\"],\"hasOptionalPrefix\":false},{\"path\":\"/user/:userId\",\"regex\":\"^/user/([^/]+)$\",\"paramNames\":[\"userId\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/dev/lockup\"},{\"path\":\"/dev/preview\"},{\"path\":\"/privacy\"},{\"path\":\"/support\"},{\"path\":\"/terms\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.3.0";globalThis["_sentryRewritesTunnelPath"] = "/monitoring";import * as Sentry from '@sentry/nextjs';
import { dropLocalhostEvents, isLocalHostname } from '@/lib/sentry-filter';
import { installSentrySourceMapSmoke } from '@/lib/sentry-sourcemap-smoke';

// Skip Sentry entirely on localhost so local dev — including a local prod
// build run against a pulled production env — never reaches the issue
// stream (errors, replays, or transactions). See lib/sentry-filter.ts.
const isLocal =
  typeof window !== 'undefined' && isLocalHostname(window.location.hostname);

Sentry.init({
  dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
  enabled: !isLocal,

  // 10% sampling in production for cost control; full sampling in dev
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1,

  // Replay: 10% of all sessions, plus 100% of sessions with an error
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,

  // Enable logs to be sent to Sentry
  enableLogs: true,

  // Capture user agent / IP. Acceptable for a marketing landing page where
  // we're not handling sensitive user data.
  sendDefaultPii: true,

  // Backstop in case `enabled` is bypassed (e.g. an event queued before the
  // hostname check): never report events that originate from localhost.
  beforeSend: dropLocalhostEvents,

  integrations: [
    Sentry.replayIntegration({
      // Don't mask anything — this is a public marketing page with no PII
      maskAllText: false,
      blockAllMedia: false,
    }),
    Sentry.browserTracingIntegration(),
  ],

  // Filter third-party browser-extension noise. These errors are injected
  // into the page by extensions (password managers, ad blockers, tab
  // managers, etc.) running in a visitor's browser — they do not originate
  // from any NextUp application code. Patterns are kept tight so genuine app
  // errors are never swallowed.
  // See: https://github.com/nxt-up/nextup-web/issues/52
  //      https://github.com/nxt-up/nextup-web/issues/53
  ignoreErrors: [
    // #53: extensions calling chrome/browser.runtime.sendMessage() against a
    // tab that has been closed or is otherwise unavailable.
    /runtime\.sendMessage/,
    /Extension context invalidated/,
    // #52: ReferenceErrors for symbols that exist only in extension-injected
    // scripts (observed on the non-existent /v2 route, no app stacktrace).
    /InsetSubmitButton is not defined/,
    /SiteHeader is not defined/,
  ],

  // Drop any event whose error originates from an extension script URL. This
  // covers the broad class of extension noise without enumerating messages.
  denyUrls: [
    /^chrome-extension:\/\//,
    /^moz-extension:\/\//,
    /^safari-extension:\/\//,
    /^safari-web-extension:\/\//,
  ],
});

if (typeof window !== 'undefined') {
  installSentrySourceMapSmoke({
    vercelBuild: process.env.NEXT_PUBLIC_VERCEL,
    vercelEnv: process.env.NEXT_PUBLIC_VERCEL_ENV,
    target: window,
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
